import { Spinner } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';
import { isLoadingSelector, loadingMsgSelector } from './feedbackSlice';

export default () => {
  const isLoading = useSelector(isLoadingSelector);
  const loadingMsg = useSelector(loadingMsgSelector);

  const classes = createUseStyles({
    loading: {
      top: 0,
      left: 0,
      position: 'fixed',
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      background: 'rgba(255,255,255,.7)',
      zIndex: 10000,
    },
  })();
  return (
    (isLoading && (
      <div className={classes.loading}>
        <Spinner
          animation="border"
          variant="primary"
          role="status"
          style={{ width: '3em', height: '3em' }}>
          <span className="sr-only">Cargando...</span>
        </Spinner>
        <h6>{loadingMsg}</h6>
      </div>
    )) ||
    null
  );
};
